<template>
	<div
			id="services-page"
			class="home"
			:class="theme">
		<nav-bar></nav-bar>
		<swiper :options="swiperOption" ref="mySwiper3">
			<swiper-slide>
				<div style="height: 100%; background-image: url('../assets/img/b1.jpg'); background-size: cover; background-repeat: no-repeat;">
					<div class="slide-center">
						<h1 class="page__title-white">{{ $t('Customer_Service') }}</h1>
					</div>
				</div>
			</swiper-slide>
		</swiper>
		<div id="quote-form" class="page">
			<h1 class="page__title">{{ $t('Customer_Service') }}</h1>
			<hr class="page__hr">

			<div class="page__container main">
				<div>
					<p>
						<strong>BARNA- TASA S.A.</strong>, {{ $t('appraisal_company')
						}}, {{ $t('Customer_Service_text_01') }} <strong>{{ $t('Customer_Service')
						}}</strong>, {{ $t('Customer_Service_text_02') }}.
					</p>
					<p>
						{{ $t('Customer_Service_text_03') }}:
					  </p>
					<ol>
						<li>
							<p>
								{{ $t('Customer_Service_text_04') }}.
							  </p>
						</li>
						<li>
							<p>
								{{ $t('Customer_Service_text_05') }}.
							  </p>
						</li>
					</ol>
					<p>
						{{ $t('Customer_Service_text_06') }}. {{ $t('Customer_Service_text_09') }}:
					</p>

					<ul>
						<li>
							<p>
								<a href="https://www.boe.es/diario_boe/txt.php?id=BOE-A-2004-5290"
								   target="_blank"><strong> &#8594;
									{{ $t('Customer_Service_text_12') }}.</strong></a>
							</p>
						</li>
						<li>
							<p>
								<a href="https://www.boe.es/diario_boe/txt.php?id=BOE-A-2011-4117"
								   target="_blank"><strong> &#8594;
									{{ $t('Customer_Service_text_10') }}.</strong></a>
							</p>
						</li>
						<li>
							<p>
								<a href="https://www.boe.es/diario_boe/txt.php?id=BOE-A-2012-14363"
								   target="_blank"><strong> &#8594;
									{{ $t('Customer_Service_text_11') }}.</strong></a>
							</p>
						</li>

					</ul>
					<p>
						{{ $t('Customer_Service_text_13') }}:

					  </p>

					<ul>
						<li>
							<p>
								{{ $t('Customer_Service_text_14') }}:
							</p>


							<p>
								<strong>BARNA-TASA S.A.</strong>
							</p>
							<p>
								<strong>Servicio de atención al cliente</strong>
							</p>
							<p>
								<strong>Còrsega, 168, 1º 1ª</strong>
							</p>
							<p>
								<strong>08036 - Barcelona</strong>
							</p>
						</li>
					</ul>
					<p>
						{{ $t('By') }} {{ $t('e-mail') }}:
						  </p>
					<ul>
						<p>
							<strong>servicio.cliente@barnatasa.com</strong>
						</p>
					</ul>
					<p>
						{{ $t('Customer_Service_text_15') }}:
						  </p>
					<ul>
						<p>
							<strong>BARNA-TASA S.A.</strong>
						</p>
						<p>
							<strong>Servicio de atención al cliente</strong>
						</p>
						<p>
							<strong>Còrsega, 168, 1º 1ª</strong>
						</p>
						<p>
							<strong>08036 - Barcelona</strong>
						</p>
					</ul>
					<p>
						<u>{{ $t('Customer_Service_text_16') }} <a
								href="http://barnatasa.com/wordpress/wp-content/uploads/2016/07/Hoja_Reclam.pdf"
								target="_blank"><strong> &#8594;{{ $t('link')
							}}</strong></a>. {{ $t('Customer_Service_text_17') }}:</u>
					</p>
					<ul>
						<li>
							<p>
								{{ $t('Customer_Service_text_18') }}.

							  </p>
						</li>
						<li>
							<p>
								{{ $t('Customer_Service_text_19') }}.

							  </p>
						</li>
						<li>
							<p>
								{{ $t('Customer_Service_text_20') }}.

							  </p>
						</li>
						<li>
							<p>
								{{ $t('Customer_Service_text_21') }}.

							  </p>
						</li>
						<li>
							<p>
								{{ $t('Customer_Service_text_22') }}.

							  </p>
						</li>
						<li>
							<p>
								{{ $t('Customer_Service_text_23') }}.

							  </p>
						</li>
						<li>
							<p>
								{{ $t('Customer_Service_text_24') }}.

							  </p>
						</li>
						<li>
							<p>
								{{ $t('Customer_Service_text_25') }}.

							  </p>
						</li>
					</ul>

					<p>
						<a href="../assets/pdf/Reg_SAC.pdf"
						   target="_blank"><strong> &#8594;
							{{ $t('Customer_Service_text_07') }}</strong></a>
					</p>
					<p>
						<a href="../assets/pdf/Hoja_Reclam.pdf"
						   target="_blank"><strong> &#8594; {{ $t('Customer_Service_text_08') }}</strong></a>
					</p>


					<p>
						{{ $t('Customer_Service_text_26') }}:

					  </p>


					<p>
						<strong>BANCO DE ESPAÑA</strong>
					</p>
					<p>

						Departamento de Conducta de Mercado y Reclamaciones

					  </p>
					<p>
						c/ Alcalá, 48

					  </p>
					<p>
						28014- Madrid

					  </p>


					<p>
						{{ $t('Customer_Service_text_27') }}: <a
							href="https://clientebancario.bde.es"
							target="_blank"><strong>Reclamaciones - Oficina Virtual (Banco de España)</strong></a>

					</p>

				</div>

			</div>

		</div>
		<logo-bar></logo-bar>
		<footer-bar></footer-bar>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Vue from 'vue'
    import { localStorageMixin } from '../mixins'
    import Message from '../components/Message.vue'
    import FooterBar from '../components/FooterBar.vue'
    import NavBar from '../components/NavBar.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import LogoBar from '../components/LogoBar.vue'

    export default {
        name: 'customer-service',

        mixins: [localStorageMixin],

        components: {
            Message,
            FooterBar,
            LogoBar,
            NavBar,
            swiper,
            swiperSlide
        },

        data: () => ({
            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        }),
        computed: {
            ...mapGetters(['user',
                'theme'])
        },
        methods: {
            ...mapActions(['LOG_IN_USER']),
            closeMessage () {
                this.error = null
            }
        },
        head: {
            title: {
                inner: 'Services'
            }
        }
    }
</script>

<style scoped>
	.swiper-container {
		height: 40vh;
		width: 100%;
	}

	.slide-img {
		width: 100%;
		height: auto;
	}
</style>


// WEBPACK FOOTER //
// CustomerService.vue?b03327fc